import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#17A2B8',
        secondary: '#FEC400',
        error: '#D25D5D',
        info: '#6AD4EE',
        success: '#3EA372',
        warning: '#FEC400',
        grey: '#212121',
        'light-grey': '#757575',
        'bright-grey': '#ADADAD'
      }
    }
  }
});
